import React from "react";
import { FiInfo } from "react-icons/fi";

/** Strip non-digits and remove leading zeros (e.g. "0232" → "232"). */
function normalizeLicenceInput(raw) {
  if (raw === "" || raw == null) return "";
  const digits = String(raw).replace(/\D/g, "");
  if (digits === "") return "";
  return String(parseInt(digits, 10));
}

function LicenceStepper({ value, onChange, onDecrement, onIncrement, disabledMinus, disabledPlus }) {
  const handleInputChange = (raw) => {
    const normalized = normalizeLicenceInput(raw);
    onChange(normalized === "" ? "" : normalized);
  };

  return (
    <div className="licence-stepper">
      <button
        type="button"
        className="licence-stepper__btn"
        onClick={onDecrement}
        disabled={disabledMinus}
        aria-label="Decrease"
      >
        −
      </button>
      <input
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        className="licence-stepper__input"
        value={value}
        onChange={(e) => handleInputChange(e.target.value)}
        onBlur={(e) => {
          if (e.target.value === "") {
            onChange("0");
          }
        }}
        aria-label="Licence count"
      />
      <button
        type="button"
        className="licence-stepper__btn"
        onClick={onIncrement}
        disabled={disabledPlus}
        aria-label="Increase"
      >
        +
      </button>
    </div>
  );
}

function LicenceColumn({
  icon: Icon,
  iconModifier,
  title,
  description,
  value,
  onChange,
  onDecrement,
  onIncrement,
  disabledMinus,
  disabledPlus,
  error,
}) {
  return (
    <div className="licence-allocation-col">
      <span className={`licence-allocation-col__icon licence-allocation-col__icon--${iconModifier}`}>
        <Icon size={22} />
      </span>
      <div className="licence-allocation-col__title">{title}</div>
      <div className="licence-allocation-col__desc">{description}</div>
      <LicenceStepper
        value={value}
        onChange={onChange}
        onDecrement={onDecrement}
        onIncrement={onIncrement}
        disabledMinus={disabledMinus}
        disabledPlus={disabledPlus}
      />
      {error ? <small className="text-danger licence-allocation-col__error">{error}</small> : null}
    </div>
  );
}

export default function LicenceAllocationPanel({
  columns = [],
  noteMessage,
  showNote = true,
  footerNote,
  availableSummary,
  subtitle = "Assign licenses for this company",
}) {
  return (
    <section className="licence-allocation-panel">
      <div className="licence-allocation-panel__header">
        <div>
          <h5 className="licence-allocation-panel__title">Licence allocation</h5>
          <p className="licence-allocation-panel__subtitle">{subtitle}</p>
        </div>
        {showNote && noteMessage ? (
          <div className="licence-allocation-panel__note">
            <FiInfo className="licence-allocation-panel__note-icon" aria-hidden />
            <span>
              <strong>Note: </strong>
              {noteMessage}
            </span>
          </div>
        ) : null}
      </div>

      <div className="licence-allocation-panel__grid">
        {columns.map((col) =>
          col.hidden ? null : (
            <LicenceColumn key={col.key} {...col} />
          )
        )}
      </div>

      {footerNote ? (
        <div className="licence-allocation-panel__footer-note">
          <FiInfo className="licence-allocation-panel__note-icon" aria-hidden />
          <span>
            <strong>Note: </strong>
            {footerNote}
          </span>
        </div>
      ) : null}

      {availableSummary ? (
        <div className="licence-allocation-panel__available">{availableSummary}</div>
      ) : null}
    </section>
  );
}
